import React from "react";

const FIELDS = [
    ["linkfacebook", "Facebook URL", "https://facebook.com/..."],
    ["linkinstagram", "Instagram URL", "https://instagram.com/..."],
    ["linktwitter", "Twitter / X URL", "https://twitter.com/..."],
    ["linklinkedin", "LinkedIn URL", "https://linkedin.com/..."],
];

export default function PoliticalSocialTab({ form, set }) {
    return (
        <div className="card shadow-sm mb-3">
            <div className="card-header bg-light fw-semibold">Social Links</div>
            <div className="card-body">
                <div className="row g-3">
                    {FIELDS.map(([key, label, ph]) => (
                        <div className="col-md-6" key={key}>
                            <label className="form-label small">{label}</label>
                            <input className="form-control form-control-sm" placeholder={ph} value={form[key] || ""} onChange={(e) => set(key, e.target.value)} />
                        </div>
                    ))}
                    <div className="col-12">
                        <label className="form-label small">YouTube Channel / Featured Video Link</label>
                        <input className="form-control form-control-sm" placeholder="https://www.youtube.com/..." value={form.youtube_link || ""} onChange={(e) => set("youtube_link", e.target.value)} />
                        <small className="form-text text-muted mt-1">
                            Shown as a YouTube icon in the footer. If you haven't added any videos in <b>Gallery &amp; Videos</b>, a watch link here appears as a single video.
                        </small>
                    </div>
                </div>
                <small className="form-text text-muted mt-3 d-block">Only links you fill in appear as icons in the footer.</small>
            </div>
        </div>
    );
}